import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useDeleteClass() {
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function deleteEST(classID) {
    return privateFetch.delete(`/v1/admin/class/${classID}`);
  }

  function manageClass(data = {}) {
    return deleteEST(data.classID);
  }

  return useMutation(manageClass, {
    onSuccess() {},
    onSettled() {
      // this will invalidate all queries starting with 'est-lists'
      queryClient.invalidateQueries('class-lists');
    },
  });
}

export default useDeleteClass;
